export default class DragController { 
    target: { panX: number, panX: number }
    mouseDown: boolean
    mousePanning: boolean
    lastX: number
    lastY: number
    x: number 
    y: number

    constructor(target: { panX: number, panY: number}) {
        this.target = target
        this.reset()
    }

    reset() {
        this.mouseDown = false 
        this.mousePanning = false 
        this.lastX = 0
        this.lastY = 0
    }

    start(e, targetRef) {
        if(targetRef !== e.target) {
            this.reset()
            return
        }
        const coordinates = this.eventCoordinates(e)
        this.mouseDown = true
        this.mousePanning = false
        this.x = coordinates.x
        this.y = coordinates.y
        this.lastX = coordinates.x
        this.lastY = coordinates.y
    }

    move(e) {
        if (!this.mouseDown) return 

        const coordinates = this.eventCoordinates(e)
        const pageX = coordinates.x
        const pageY = coordinates.y

        // Panning threshold triggererd
        if (Math.abs(this.x - pageX) > 10 || Math.abs(this.x - pageX) > 10) {
            this.mousePanning = true
        }
        // Move the board
        if(this.mousePanning) {
            this.target.panX += pageX - this.lastX
            this.target.panY += pageY - this.lastY
            this.lastX = pageX 
            this.lastY = pageY
        }
    }

    release() {
        this.reset()
    }

    eventCoordinates(event): Object {
        return { 
            x: event.pageX || event.changedTouches.item(0).pageX,
            y: event.pageY || event.changedTouches.item(0).pageY
        }
    }
}



// WEBPACK FOOTER //
// ./src/lib/DragController.js